import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Guid } from 'src/utility/guid';

export interface BusMessage {
  event: string;
  payload?: any;
  action?: string;
}

export interface BusSubscriber {
  id: string;
  subject: BehaviorSubject<BusMessage>;
  events: string[];
}

@Injectable({
  providedIn: 'root',
})
export class BusService {
  private readonly subscribers = new Map<string, BusSubscriber>();
  
  constructor() {}

  register(events: string[], id?: string): BusSubscriber {
    if (!events?.length) throw new Error('At least one "event" is required to register with the BusService.');
    const sub: BusSubscriber = {
      id: id || Guid.newGuid(),
      subject: new BehaviorSubject(null),
      events: events,
    }
    this.subscribers.set(sub.id, sub);
    return sub;
  }

  unregister(id: string) {
    this.subscribers.delete(id);
  }

  post(message: BusMessage) {
    if (!message?.event) return;
    for (const sub of this.subscribers.values()) {
      if (sub.events?.includes(message.event)) {
        sub.subject.next(message);
      }
    }
  }
}
